import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { TypedDocumentNode } from '@graphql-typed-document-node/core'

import i18n from 'modules/core/lib/i18n'

import { DeleteModal } from 'modules/cost_centers/components/CostCenterAssigments/components/DeleteModal'

interface Props {
  ids: number[]
  onDelete?: () => void
  refetchQueries?: TypedDocumentNode[]
  disabled?: boolean
}

export const DeleteButton = ({ ids, onDelete, refetchQueries, disabled = false }: Props) => {
  const [confirmModal, setConfirmModal] = useState(false)

  const handleOnDelete = () => {
    onDelete?.()

    closeConfirmModal()
  }

  const openConfirmModal = () => {
    setConfirmModal(true)
  }

  const closeConfirmModal = () => {
    setConfirmModal(false)
  }

  return (
    <>
      <Button type="negative" onClick={openConfirmModal} iconName="delete" disabled={disabled}>
        {i18n.t('common.delete')}
      </Button>

      {confirmModal && (
        <DeleteModal
          ids={ids}
          onClose={closeConfirmModal}
          onSubmit={handleOnDelete}
          refetchQueries={refetchQueries}
        />
      )}
    </>
  )
}
